const prodEmail = {
  email: 'info@uae-consulting.com',
  name: 'UAE-Consulting.com'
}

const prodConsultantsEmail = {
  email: 'info@uae-consultants.com',
  name: 'UAE-Consultants.com'
}

const localEmail = {
  email: 'support@webfriends.by',
  name: 'Dev Support Email Webfriends'
}

const delegateEmails = {
  local: localEmail,
  stg: localEmail,
  prod: prodEmail,
  prodConsultants: prodConsultantsEmail
}

export default delegateEmails



// WEBPACK FOOTER //
// ./src/constants/googleApi/delegateEmails.js